import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { DataService, DateService, HelperService, HTTPService, FormatService } from 'app/services';

import { debounce, findIndex } from 'lodash';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-category-search',
  templateUrl: './category-search.component.html',
  styleUrls: ['./category-search.component.scss'],
})
export class CategorySearchComponent implements OnInit, OnDestroy {
  @Input() subId: string = '';
  @Input() isCreateModal: boolean = false;
  @Input() type: string;
  @Input() placeholder: string;
  @Input() selectedCategory: any;
  @Input() theme: string = 'border';
  @Input() canEditClassifications: boolean = false;
  @Input() preSelectedValue: string = '';
  @Input() alreadySelectedCategories: any = [];

  @Output() appSelect = new EventEmitter<any>();

  data: any[] = [];
  category: any = {};
  isShowNewCategory: boolean = false;
  isShowEditCategory: boolean = false;
  _globalSearch = debounce(() => this.dataService.updateSearchEvent(this.query), 600);
  results: any[] = [];
  query: string = '';
  currentTime: any = '';
  isLoading: boolean = false;
  isLoadingSubCat: any = {};
  selectedValue: string = '';
  isCloseDropdown: boolean = false;
  isSubCatLoading: boolean = false;
  isSubsubCatLoading: boolean = false;
  isLoadingMore: boolean = false;
  isROPrioritiesEnabled: boolean = false;
  defaultPriority: any = {};
  dataServiceSubscription: Subscription;
  totalPages: number = 0;
  pageIndex: number = 0;
  limit: number = 3;
  totalRecords: number = 0;
  isEnhancedGlobalSearchEnabled: boolean = false;
  selectedLevel1 = '';
  selectedLevel2 = '';
  selectedLevel3 = '';
  subCategories: any = [];
  partTerminology: any = [];
  activeItemIndex: number = 0;
  activeLevel2Index: number = 0;
  isLastItemSelected: boolean = false;
  selectedId: any;
  isShowSubCategory: boolean = false;
  isShowsubSubCategory: boolean = false;
  subCategoryType: string = '';
  subSubCategoryType: string = '';
  noRecord: string = 'No record found';
  isDisabledSearch: boolean = false;
  categoryTooltip: string = 'This category already has a pricing override or matrix assigned. No duplicate overrides or additional matrices can be added';

  constructor(private httpService: HTTPService, private helperService: HelperService, private dataService: DataService, private dateService: DateService, private formatService: FormatService) { }

  ngOnInit() {
    this.canEditClassifications = this.dataService.canEditClassifications;
    this.getAllCategories();
    if (this.preSelectedValue) {
      this.selectedValue = this.preSelectedValue;
    } else {
      this.setSelectedCategory();
    }
  }

  ngOnChanges(change: any) {
    // Commented this piece of code because it was overriding data for other components. If you want to do that kindly use it under any flag which you sent from your component
    // this.getAllCategories();
  }

  setSelectedCategory() {
    if (this.selectedCategory) {
      const currentCategory = this.selectedCategory;
      if (currentCategory.categoryId && currentCategory.subCategoryId && currentCategory.subSubCategoryId) {
        this.handleLevel3Change(
          { subSubCategoryId: currentCategory.subSubCategoryId, subSubCategoryName: currentCategory.subSubCategoryName },
          { subCategoryId: currentCategory.subCategoryId, subCategoryName: currentCategory.subCategoryName },
          { categoryId: currentCategory.categoryId, categoryName: currentCategory.categoryName }
        );
      } else if (currentCategory.categoryId && currentCategory.subCategoryId) {
        this.handleLevel2Change(
          { subCategoryId: currentCategory.subCategoryId, subCategoryName: currentCategory.subCategoryName },
          { categoryId: currentCategory.categoryId, categoryName: currentCategory.categoryName },
          0
        );
      } else if (currentCategory.categoryId) {
        this.handleLevel1Change({ categoryId: currentCategory.categoryId, categoryName: currentCategory.categoryName }, 0);
      }
      if (this.selectedValue) this.isDisabledSearch = true;
    }
  }

  getAllCategories() {
    this.isLoading = true;
    const query: any = {};
    if (this.query) query.searchTerm = encodeURI(this.query);
    if (this.type) query.itemType = this.type;
    this.httpService.getPricingCategories(query).then((res: any) => {
      this.data = res.categories.filter(category => category.categoryName && category._id);
      this.isLoading = false;
      this.canEditClassifications = this.dataService.canEditClassifications;
    });
  }

  categoryChecked(type: string, key: string, id: string) {
    if(type == 'category'){
      const index = findIndex(this.alreadySelectedCategories, { [key]: id });
      if(index !== -1 && (!this.alreadySelectedCategories[index]?.subCategoryId && !this.alreadySelectedCategories[index]?.subSubCategoryId)) return true;
      return false;
    }
    else if(type == 'subCategory'){
      const index = findIndex(this.alreadySelectedCategories, { [key]: id });
      if(index !== -1 && !this.alreadySelectedCategories[index]?.subSubCategoryId) return true;
      return false;
    }
    if(type == 'subSubCategory'){
      const index = findIndex(this.alreadySelectedCategories, { [key]: id });
      if(index !== -1 && (this.alreadySelectedCategories[index]?.categoryId && this.alreadySelectedCategories[index]?.subCategoryId)) return true;
      return false;
    }

    return false;
  }

  resetSearch(event) {
    if (this.isEnhancedGlobalSearchEnabled && event) this.query = '';
  }

  ngOnDestroy() {
    if (this.dataServiceSubscription) {
      this.dataServiceSubscription.unsubscribe();
    }
  }

  handleSelect(option: any) {
    // console.log(option);
    // this.appSelect.emit(option);
    // this.dataService.sendData(this.dataService.typeSidebar('customer', customer._id, customer.fullName, { _id: customer._id }));
  }

  handleClear() {
    this.isLoading = false;
    this.results = [];
    this.query = '';
    this.getAllCategories()
  }

  onSearchEnter() {
    if (this.results.length) {
      this.query = '';
      this.results = [];
    }
  }

  handleSearch(query: string) {
    this.query = query;
    this.selectedValue = query;
    this.isDisabledSearch = false;
    this.isLastItemSelected = false;
    if (this.query.length) this.getAllCategories();
  }

  closeDropdown() {
    this.isCloseDropdown = true;
    if (this.selectedValue === this.query) this.selectedValue = '';
    this.handleClear();
  }

  handleShowMore(event: Event) {
    event.stopPropagation();
    event.preventDefault();

    this.pageIndex++;
    this.handleSearch(this.query);
  }

  change() {
    return false;
  }

  handleLevel1Change(level1, i) {
    this.selectedLevel2 = '';
    this.selectedLevel3 = '';

    this.isLastItemSelected = false;
    this.selectedLevel1 = level1.categoryId;
    this.getSubcategories(level1, i);
    if (this.theme !== 'border') this.selectedValue = `${level1.categoryName}`;
  }

  handleLevel2Change(level2, level1, i) {
    this.selectedLevel1 = '';
    this.selectedLevel2 = '';
    this.selectedLevel3 = '';
    this.selectedLevel1 = level1.categoryId;
    this.selectedLevel2 = level2.subCategoryId;
    this.getSubSubcategories(level1, level2, i);
    this.isLastItemSelected = false;
    if (this.theme !== 'border') this.selectedValue = `${level1.categoryName} > ${level2.subCategoryName}`;
  }

  handleLevel3Change(level3, level2, level1) {
    this.selectedLevel1 = '';
    this.selectedLevel2 = '';
    this.selectedLevel3 = '';
    this.selectedLevel3 = level3.subSubCategoryId;
    this.selectedLevel2 = level2.subCategoryId;
    this.selectedLevel1 = level1.categoryId;
    // this.isLastItemSelected = true;
    if (this.theme !== 'border') this.selectedValue = `${level1.categoryName} > ${level2.subCategoryName} > ${level3.subSubCategoryName}`;
    const option = {
      level3,
      level2,
      level1,
    };
    this.appSelect.emit(option);
  }

  handleCloseDropdown() {
    this.isLastItemSelected = true;
  }

  handleCreateNewCategory(value) {
    this.isShowNewCategory = value;
    this.isShowEditCategory = false;
    this.category.categoryName = '';
    this.category.categoryId = '';
  }

  handleChangeCategory(type, e) {
    this.category[type] = e;
  }

  createCategory() {
    this.isLoading = true;
    const data = {
      categoryName: this.category.categoryName,
      itemType: this.type,
    };
    this.httpService.createCategory(data).then(
      (res: any) => {
        console.log(res);
        this.category.categoryName = '';
        this.isShowNewCategory = false;
        this.getAllCategories();
      },
      (err) => {
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  opneEditCategoryName(item) {
    this.isShowNewCategory = false;
    this.isShowEditCategory = true;
    this.category.categoryName = item.categoryName;
    this.category.categoryId = item.categoryId;
  }

  handleUpdateCategory() {
    this.isLoading = true;
    const data = {
      categoryName: this.category.categoryName,
      itemType: this.type,
      categoryId: this.category.categoryId,
    };
    this.httpService.updateCategory(data).then(
      (res: any) => {
        console.log(res);
        this.category.categoryName = '';
        this.category.categoryId = '';
        this.isShowEditCategory = false;
        this.getAllCategories();
        this.isLoading = false;
      },
      (err) => {
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  cancelEditCategory(item) {
    this.isShowNewCategory = false;
    this.isShowEditCategory = false;
    this.category.categoryName = '';
    this.category.categoryId = '';
  }

  getSubcategories(item, index = 0, isChevron = false) {
    this.isLastItemSelected = false;
    this.isSubCatLoading = true;
    this.isShowSubCategory = false;
    this.activeItemIndex = index;
    this.selectedId = item.categoryId;
    this.isLoadingSubCat[this.selectedId] = true;

    this.httpService.getPricingSubCategories(item.categoryId, this.type, this.query).then(
      (res: any) => {
        if (res && res.subCategories?.length) {
          item.subItems = res.subCategories;
        } else {
          item.subItems = [];
        }
        if (!isChevron) {
          const option = {
            level1: item,
          };
          this.appSelect.emit(option);
        }
        this.isSubCatLoading = false;
        this.isLoadingSubCat[this.selectedId] = false;
      },
      (err) => {
        this.isSubCatLoading = false;
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  getSubSubcategories(item, level2, index = 0, isChevron = false) {
    this.isLastItemSelected = false;
    this.isSubsubCatLoading = true;
    this.activeLevel2Index = index;
    this.selectedId = level2.subCategoryId;
    this.isLoadingSubCat[this.selectedId] = true;
    this.httpService.getPricingSubSubCategories(item.categoryId, level2.subCategoryId, this.type, this.query).then(
      (res: any = {}) => {
        if (res && res.subSubCategories?.length) {
          level2.subItems = res.subSubCategories;
        } else {
          level2.subItems = [];
        }
        if (!isChevron) {
          const option = {
            level2,
            level1: item,
          };
          this.appSelect.emit(option);
        }
        this.isLoadingSubCat[this.selectedId] = false;
        this.isSubsubCatLoading = false;
        this.isLoading = false;
      },
      (err) => {
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  deleteCategoryDialog(e) { }

  openSubCategory(val, item, type, index = 0) {
    this.activeItemIndex = index;
    this.isShowSubCategory = val;
    this.subCategoryType = type;
    this.category.categoryId = item.categoryId;

    if (!val) {
      this.category.subCategoryName = '';
      this.category.categoryId = '';
    }
  }

  createSubCategory(categoryId) {
    this.isLoading = true;
    const data = {
      subCategoryName: this.category.subCategoryName,
      itemType: this.type,
      categoryId: categoryId,
    };
    this.httpService.createSubCategory(data).then(
      (res: any) => {
        console.log(res);
        this.category = {};
        this.isShowSubCategory = false;
        this.getAllCategories();
        this.isLoading = false;
      },
      (err) => {
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  updateSubCategory(categoryId) {
    this.isLoading = true;
    const data = {
      itemType: this.type,
      categoryId: categoryId,
      subCategoryId: this.category.subCategoryId,
      subCategoryName: this.category.subCategoryName,
    };
    this.httpService.updateSubCategory(data).then(
      (res: any) => {
        console.log(res);
        this.category = {};
        this.isShowSubCategory = false;
        this.getAllCategories();
        this.isLoading = false;
      },
      (err) => {
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  handleEditSubCategory(item, level2) {
    this.isShowSubCategory = true;
    this.subCategoryType = 'update';
    this.category.subCategoryName = level2.subCategoryName;
    this.category.subCategoryId = level2.subCategoryId;
    this.category.categoryName = item.categoryName;
  }

  openNewSubsubCategory(value, subSubcategory, item, level2) {
    this.isShowsubSubCategory = value;
    this.subSubCategoryType = subSubcategory;

    this.category.categoryId = item.categoryId;
    this.category.subCategoryId = level2.subCategoryId;
  }

  openEditSubsubCategory(value, subSubcategory, item, level2, level3) {
    this.isShowsubSubCategory = value;
    this.subSubCategoryType = subSubcategory;

    this.category.categoryId = item.categoryId;
    (this.category.subCategoryId = level2.subCategoryId), (this.category.subSubCategoryId = level3.subSubCategoryId);
  }

  createSubSubCategory() {
    this.isLoading = true;
    const data = {
      itemType: this.type,
      subSubCategoryName: this.category.subSubCategoryName,
      categoryId: this.category.categoryId,
      subCategoryId: this.category.subCategoryId,
    };
    this.httpService.createSubSubCategory(data).then(
      (res: any) => {
        console.log(res);
        this.category = {};
        this.isShowSubCategory = false;
        this.getAllCategories();
        this.isLoading = false;
      },
      (err) => {
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  updateSubSubCategory() {
    this.isLoading = true;
    const data = {
      itemType: this.type,
      categoryId: this.category.categoryId,
      subCategoryId: this.category.subCategoryId,
      subSubCategoryId: this.category.subSubCategoryId,
      subSubCategoryName: this.category.subSubCategoryName,
    };
    this.httpService.updateSubCategory(data).then(
      (res: any) => {
        console.log(res);
        this.category = {};
        this.isShowSubCategory = false;
        this.getAllCategories();
        this.isLoading = false;
      },
      (err) => {
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  handleDeleteItem() {
    this.selectedValue = '';
    this.appSelect.emit({});
    this.selectedLevel1 = '';
    this.selectedLevel2 = '';
    this.selectedLevel3 = '';
  }

  highlighedSearchText(text: string, query: string) {
    return this.formatService.highlighedSearchText(text, query);
  }

  highlighedSubSearchText(text: string, query: string) {
    return this.formatService.highlighedSearchTextEnhancement(text, query);
  }
}
